import axios from "./axiosConfig";
import { apis } from "./params";

// @@ AI-COMMENT: Fetch stock alerts listing
export function getSupplierStockAlerts(data: any) {
    return axios({
        method: "POST",
        url: apis.GET_SUPPLIER_STOCK_ALERTS,
        data
    });
}

// @@ AI-COMMENT: Update promise date
export function updatePromiseDate(data: { msn: string, updatedBy: string, promiseDate: string }) {
    return axios({
        method: "POST",
        url: apis.UPDATE_PROMISE_DATE,
        data
    });
}

// @@ AI-COMMENT: Update action
export function updateAction(data: { msn: string, updatedBy: string, action: string }) {
    return axios({
        method: "POST",
        url: apis.UPDATE_ACTION_ALERT,
        data
    });
}

// @@ AI-COMMENT: Update reason
export function updateReason(data: { msn: string, updatedBy: string, reason: string }) {
    return axios({
        method: "POST",
        url: apis.UPDATE_REASON_ALERT,
        data
    });
}

// @@ AI-COMMENT: Get alert filters categories
export function getCategories() {
    return axios({
        method: "GET",
        url: apis.GET_ALERT_CATEGORIES
    });
}

// @@ AI-COMMENT: Get alert action list
export function getActions() {
    return axios({
        method: "GET",
        url: apis.GET_ALERT_ACTIONS
    });
}

// @@ AI-COMMENT: Get alert reason list
export function getReasons() {
    return axios({
        method: "GET",
        url: apis.GET_ALERT_REASONS
    });
}

// @@ AI-COMMENT: Get alert agents list
export function getAgents() {
    return axios({
        method: "GET",
        url: apis.GET_ALERT_AGENTS
    });
}

// @@ AI-COMMENT: Download stock alerts as CSV blob
export function downloadStockAlerts(data: any) {
    return axios({
        method: "POST",
        url: apis.DOWNLOAD_SUPPLIER_STOCK_ALERTS,
        data,
        responseType: "blob"
    });
}

// @@ AI-COMMENT: Fetch change history for a given MSN
export function getStockAlertHistory(msn: string) {
    return axios({
        method: "GET",
        url: `${apis.GET_STOCK_ALERT_HISTORY}/${msn}`
    });
}

// @@ AI-COMMENT: Update note
export function updateNote(data: { msn: string, updatedBy: string, notes: string }) {
    return axios({
        method: "POST",
        url: apis.UPDATE_NOTE_ALERT,
        data
    });
}

// @@ AI-COMMENT: Fetch alert data from the supplier side
export function refreshStockAlerts() {
    return axios({
        method: "GET",
        url: apis.REFRESH_STOCK_ALERTS
    });
}

